// Согласно УКЗ: https://jira.sberbank.ru/browse/AMS-822

const sanitizeReg = /[^a-zA-Zа-яА-ЯёЁ0-9 ,.+×÷=_€£¥₽!@$%^():;?~|•§°»«-]/g;
const multipleSpacesReg = / +/g; // Множественные пробелы
const multipleHyphensReg = /-+/g; // Множественные дефисы

export const sanitizeUserComment = (comment: string) => {
  // Сначала заменяем запрещенные символы на пробелы
  let sanitized = comment.replace(sanitizeReg, ' ');
  // Затем заменяем множественные пробелы на одинарные
  sanitized = sanitized.replace(multipleSpacesReg, ' ');
  // Затем заменяем множественные дефисы на одинарные
  sanitized = sanitized.replace(multipleHyphensReg, '-');

  return sanitized;
};
